var _g, _path, _g2, _g3, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlusSide(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 51,
    viewBox: "0 0 54 51",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "PLUS-side 1",
    clipPath: "url(#clip0_3756_2563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3756_2563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 51
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "clip0_3753_2454"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M54 0H0V51H54V0Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3756_2563)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Stroke",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24 47.58C36.1944 47.58 45.08 38.6944 45.08 26.5C45.08 14.3055 36.1944 5.42 24 5.42C11.8055 5.42 2.92 14.3055 2.92 26.5C2.92 38.6944 11.8055 47.58 24 47.58ZM24 49.5C37.2548 49.5 47 39.7548 47 26.5C47 13.2452 37.2548 3.5 24 3.5C10.7451 3.5 1 13.2452 1 26.5C1 39.7548 10.7451 49.5 24 49.5Z",
    fill: "url(#paint0_linear_3756_2563)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "PLUS-nav 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Clip path group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask group"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_3756_2563",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 54,
    height: 51
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "clip0_15695_96042"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M54 0H0V51H54V0Z",
    fill: "white"
  }))))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_3756_2563)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "PLUS-nav"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Molecule / Avatar / Profile 117"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 1398"
  }, /*#__PURE__*/React.createElement("path", {
    id: "+ (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M50.3925 7.73838C51.1425 8.48827 51.2949 9.40689 51.2949 10.0101V12.7113C51.2949 13.3145 51.1425 14.2332 50.3925 14.983C49.6426 15.7329 48.724 15.8854 48.1209 15.8854H44.8197V19.1072C44.8197 19.7103 44.6672 20.6289 43.9173 21.3789C43.1674 22.1288 42.2488 22.2812 41.6456 22.2812H38.9839C38.3808 22.2812 37.4622 22.1288 36.7123 21.3789C35.9624 20.6289 35.8099 19.7103 35.8099 19.1072V15.8854H32.469C31.8658 15.8854 30.9472 15.7329 30.1973 14.983C29.4475 14.2332 29.2949 13.3145 29.2949 12.7113V10.0101C29.2949 9.40689 29.4475 8.48827 30.1973 7.73837C30.9472 6.98848 31.8658 6.83597 32.469 6.83597H35.8099V3.45533C35.8099 2.85216 35.9624 1.93354 36.7123 1.18365C37.4622 0.433761 38.3808 0.28125 38.9839 0.28125H41.6456C42.2488 0.28125 43.1674 0.433761 43.9173 1.18365C44.6672 1.93355 44.8197 2.85217 44.8197 3.45533V6.83597H48.1209C48.724 6.83597 49.6426 6.98848 50.3925 7.73838ZM48.7565 10.0101C48.7565 9.58627 48.5446 9.37437 48.1209 9.37437H42.5195C42.3607 9.37437 42.2812 9.29496 42.2812 9.13608V3.45533C42.2812 3.03159 42.0693 2.81971 41.6456 2.81971H38.9839C38.5602 2.81971 38.3484 3.03159 38.3484 3.45533V9.13608C38.3484 9.29496 38.2689 9.37437 38.11 9.37437H32.469C32.0453 9.37437 31.8334 9.58627 31.8334 10.0101V12.7113C31.8334 13.1351 32.0453 13.347 32.469 13.347H38.11C38.2689 13.347 38.3484 13.4264 38.3484 13.5853V19.1072C38.3484 19.5309 38.5602 19.7428 38.9839 19.7428H41.6456C42.0693 19.7428 42.2812 19.5309 42.2812 19.1072V13.5853C42.2812 13.4264 42.3607 13.347 42.5195 13.347H48.1209C48.5446 13.347 48.7565 13.1351 48.7565 12.7113V10.0101Z",
    fill: "#1C2A34"
  }), /*#__PURE__*/React.createElement("path", {
    id: "+",
    d: "M48.1213 9.37449C48.5451 9.37449 48.7569 9.58639 48.7569 10.0101V12.7114C48.7569 13.1352 48.5451 13.347 48.1213 13.347H42.52C42.3611 13.347 42.2816 13.4265 42.2816 13.5855V19.1073C42.2816 19.531 42.0698 19.7429 41.6461 19.7429H38.9844C38.5607 19.7429 38.3488 19.531 38.3488 19.1073V13.5855C38.3488 13.4265 38.2694 13.347 38.1105 13.347H32.4694C32.0457 13.347 31.8338 13.1352 31.8338 12.7114V10.0101C31.8338 9.58639 32.0457 9.37449 32.4694 9.37449H38.1105C38.2694 9.37449 38.3488 9.29508 38.3488 9.1362V3.45543C38.3488 3.03169 38.5607 2.81982 38.9844 2.81982H41.6461C42.0698 2.81982 42.2816 3.03169 42.2816 3.45543V9.1362C42.2816 9.29508 42.3611 9.37449 42.52 9.37449H48.1213Z",
    fill: "url(#paint1_linear_3756_2563)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 41 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5581 3.51562C39.8125 3.51562 40.0187 3.72186 40.0187 3.97626V10.6001C40.0187 10.8545 39.8125 11.0607 39.5581 11.0607H32.9872C32.7328 11.0607 32.5266 10.8545 32.5266 10.6001C32.5266 10.3457 32.7328 10.1394 32.9872 10.1394H39.0975V3.97626C39.0975 3.72186 39.3037 3.51562 39.5581 3.51562Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 42 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M39.5584 15.5601C39.8128 15.5601 40.0191 15.7663 40.0191 16.0207V18.5856C40.0191 18.84 39.8128 19.0463 39.5584 19.0463C39.304 19.0463 39.0978 18.84 39.0978 18.5856V16.0207C39.0978 15.7663 39.304 15.5601 39.5584 15.5601Z",
    fill: "#F7FCFD",
    fillOpacity: 0.8
  }))))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_3756_2563",
    x1: 48,
    y1: 50.5,
    x2: 4.24844,
    y2: -1.1021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66E86"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_3756_2563",
    x1: 47.9184,
    y1: 19.7429,
    x2: 32.3113,
    y2: 3.15959,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A464DA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F66E86"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3756_2563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 51,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlusSide);
export default __webpack_public_path__ + "static/media/PLUS-side.66b7e7a707034ac37ab7102836d773e6.svg";
export { ForwardRef as ReactComponent };